export default __webpack_public_path__ + "cisco.gif";